/**
 * Configuration file for local development
 * These values are only used in development mode (NODE_ENV === 'development')
 * In production, authentication is handled by OAuth2
 */

const config = {
  development: {
    // User information for local development
    // Override these values locally if needed
    userEmail: process.env.REACT_APP_DEV_USER_EMAIL || 'admin@daimlerTruck.com',
    userId: process.env.REACT_APP_DEV_USER_ID || 'xKReAO2gYJO_5ETEFMucTJhwQUc_7ITO1pNzzQVPDfw',
    emailId: process.env.REACT_APP_DEV_EMAIL_ID || '6de272e5-eee3-432c-bd9a-e64a4957b4ff',
    preferredUsername: process.env.REACT_APP_DEV_USERNAME || 'admin@daimlerTruck.com'
  }
};

export default config;
